var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMountains = function SvgMountains(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 400,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m387.377 260.667-70.723-97.414L64 400l2.559-.087L213.76 274.607l25.825 23.282 35.364-28.04 27.676 30.331 40.188-32.629 58.02 24.511 44.783 61.36 6.369-.216-60.083-86.201 100.308-106.873 15.652 26.019 35.364-28.042 27.677 30.332 40.187-32.63 57.614 24.34 71.883 96.997 46.369 64.765 6.428-.217-44.862-66.424 106.462-110.397 14.658 24.366 35.362-28.041 27.676 30.332 40.192-32.63 57.687 24.372 167.84 190.612 1.6-.053L938.503 54.035 743.978 268.911 583.228 52z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Mountains_svg__a)",
    d: "m387.377 260.667-70.723-97.414L64 400l2.559-.087L213.76 274.607l25.825 23.282 35.364-28.04 27.676 30.331 40.188-32.629 58.02 24.511 44.783 61.36 6.369-.216-60.083-86.201 100.308-106.873 15.652 26.019 35.364-28.042 27.677 30.332 40.187-32.63 57.614 24.34 71.883 96.997 46.369 64.765 6.428-.217-44.862-66.424 106.462-110.397 14.658 24.366 35.362-28.041 27.676 30.332 40.192-32.63 57.687 24.372 167.84 190.612 1.6-.053L938.503 54.035 743.978 268.911 583.228 52z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Mountains_svg__a",
    x1: 588.36,
    x2: 592.771,
    y1: 51.774,
    y2: 355.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C1110"
  })))));
};
export default SvgMountains;